import { render, staticRenderFns } from "./GroupSelector.vue?vue&type=template&id=9dee8ea8&"
import script from "./GroupSelector.vue?vue&type=script&lang=js&"
export * from "./GroupSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports